// LockBanner — sticky banner for one of three scenarios (§1.6 / §1.7):
//
//   kind === 'stolen'             → "You no longer hold the lock. {holder} took over."
//   kind === 'archived'           → "This application group is closed. Draft archived on …"
//   kind === 'not-on-active-list' → "This group is not currently in the active list …"

interface LockBannerProps {
  kind: 'stolen' | 'archived' | 'not-on-active-list';
  message: string;
}

// Stolen is a hard interruption (danger); archived is neutral info; not-on-list
// is advisory (warning). Keep role=alert only for the stolen case so screen
// readers don't shout the advisory variants.
const BANNER_TONE: Record<LockBannerProps['kind'], 'danger' | 'info' | 'warning'> = {
  stolen: 'danger',
  archived: 'info',
  'not-on-active-list': 'warning',
};

export function LockBanner({ kind, message }: LockBannerProps): React.JSX.Element {
  return (
    <div
      role={kind === 'stolen' ? 'alert' : 'status'}
      className="alert"
      data-tone={BANNER_TONE[kind]}
      style={{ margin: 'var(--space-4) var(--space-5)' }}
    >
      <div className="alert-body">{message}</div>
    </div>
  );
}
